// src/components/_ui/NewsOffers/NewsOffers.jsx
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import AOS from "aos";
import "./NewsOffers.scss";

const SectionTitle = () => (
  <div className="title-wrap">
    <h2>Inside access. No fluff.</h2>
  </div>
);

export const NewsOffers = () => {
  const history = useHistory();

  useEffect(() => {
    AOS.init({ duration: 2000, mirror: true });
  }, []);

  return (
    <div id="subscribe" className="newsOffers">
      <div
        className="component"
        data-aos="fade-up"
        data-aos-offset="-200"
        data-aos-duration="700"
      >
        {/* mobile title */}
        <div className="title-wrap show-below-767">
          <SectionTitle />
        </div>

        <div className="content-wrap">
          <div className="left">
            {/* desktop title */}
            <div className="title-wrap show-above-767">
              <SectionTitle />
            </div>
            <p>
              Get original insights, new opportunities, and updates on what we’re building and where we’re headed.
            </p>
          </div>
          <div className="right">
            <div className="btn-wrap">
              <button
                onClick={() => history.push("/sign-up")}
                className="btn btn-primary"
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsOffers;
